import styled from "styled-components"

export const ElectionInfoIframe = styled.iframe`
    height: 900px;
    width: 100%;
    border: none;
    overflow: hidden;
`
